import React from 'react'
import axios from 'axios'
import {Link} from "react-router-dom";


class MenuBar extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {roles:'',management:'',administrative:'',hrs:'',accountant:'',manager:'',emp:'', user:localStorage.getItem('tokens'),
						CompName:'',names:''};				
	}
	
	componentDidMount() {				
		const para={LID:this.state.user}
		axios.post(process.env.REACT_APP_API_ENV+'api/userinformationemp.php',para)
			.then(result => {						
				this.setState({management:result.data[5]})													
				this.setState({administrative:result.data[6]})		
				this.setState({hrs:result.data[7]})		
				this.setState({accountant:result.data[8]})		
				this.setState({manager:result.data[9]})		
				this.setState({emp:result.data[10]})								
				this.setState({roles:result.data[2]})			
				this.setState({names:result.data[1]})	
			})		
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})				
	}
	
	render() {				
		return (
			<div id="buttons">
				<label style={{width: '120px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/Application">Application</Link></label>							
				{this.state.management === "1" ? <label style={{width: '138px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/Management">Management</Link></label>:""}
				{this.state.administrative==="1" ? <label style={{width: '120px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/Admin">Admin</Link></label>:""}														
				{this.state.management === "1" || this.state.accountant === "1" ? <label style={{width: '120px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/Report">Report</Link></label>:""}
				<label style={{width: '120px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/Search">Search</Link></label>				
				<label style={{width: '120px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/MSetting">Settings</Link></label>
				<label style={{width: '120px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/Manages">Logout</Link></label>
			</div>
		)
	}	
}


export default MenuBar